module.exports = __webpack_public_path__ + "static/media/zcash.907e6bcd.png";